// Implements: F-RPT-005, F-RPT-006, F-RPT-007
/**
 * Mockup v3 P9: the query of a report's day window (`YYYY-MM-DD`, both included), `from=…&to=…`
 * in that order, shared by the organization's and the platform's report clients (modules never
 * import each other). The windows themselves are `shared/ui/reportWindows.ts`.
 */

import type { ReportWindow } from "../../types/reports";

export function reportWindowQuery(window: ReportWindow): URLSearchParams {
  return new URLSearchParams({ from: window.from, to: window.to });
}
